import type { TranslationDictionaryType } from "@shared/types/i18n.interface";

export const en = {
  "user.directory.header.title": "Event Directory",
  "user.directory.header.account": "Your account",
  "user.directory.defaultEventName": "Event",

  "user.directory.tabs.all": "All",
  "user.directory.tabs.topPicks": "Suggestions",
  "user.directory.tabs.requests": "Requests",
  "user.directory.tabs.connected": "Connected",

  "user.directory.loadingMore": "Loading more…",
  "user.directory.search.placeholder": "Search participants",
  "user.directory.search.placeholderWithCountOne": "Search 1 participant",
  "user.directory.search.placeholderWithCount": "Search {{count}} participants",
  "user.directory.search.clear": "Clear search",
  "user.directory.search.groups.names": "By name, role or company",
  "user.directory.search.groups.meaning": "By what they do",
  "user.directory.search.groups.reading": "Reading {{count}} profiles",
  "user.directory.search.groups.readingOne": "Reading 1 profile",
  "user.directory.search.groups.seeAll": "See all {{count}}",
  "user.directory.list.you": "You",
  "user.directory.index.railLabel": "Jump to a letter",

  "user.directory.topPicks.banner.title": "See your suggestions →",
  "user.directory.topPicks.banner.subtitle":
    "Or browse all {{count}} profiles (est. read time {{time}})",
  "user.directory.topPicks.banner.subtitleOne":
    "Or browse the 1 profile (est. read time {{time}})",
  "user.directory.topPicks.banner.dismiss": "Dismiss banner",

  "user.directory.topPicks.info.description":
    "Who Porter thinks you should meet.",
  "user.directory.topPicks.info.recalculating":
    "These are the suggestions I had before in case you want to browse them.",

  "user.directory.topPicks.recalculating.title": "Asking around",
  "user.directory.topPicks.recalculating.subtitle":
    "I'm working out who you could have an interesting conversation with. I'll message you when the new set is ready.",

  "user.directory.topPicks.generateMore": "Look for more",
  "user.directory.topPicks.generating": "Looking…",

  "user.directory.topPicks.isolatedGate.buttonLabel": "Look for more",
  "user.directory.topPicks.isolatedGate.legal":
    "Planta helps you make remarkable connections at events. When you become a member you activate your network and keep your profile for future events. By clicking you become a member and agree to the {{terms}} and {{privacy}}.",
  "user.directory.topPicks.isolatedGate.termsLabel": "Terms",
  "user.directory.topPicks.isolatedGate.privacyLabel": "Privacy Policy",
  "user.directory.topPicks.isolatedGate.error":
    "Something went wrong. Please try again.",
  "user.directory.empty.all.title": "No one's in the room yet.",
  "user.directory.empty.all.description":
    "Names land here as people join. You're early.",

  "user.directory.empty.topPicks.title": "I'm asking around",
  "user.directory.empty.topPicks.description":
    "Everyone here has their own Porter. I'm putting the question to a few of them, quietly.",
  "user.directory.empty.topPicks.note":
    "What goes out is the question, not you. You'll hear from me when someone worth your evening comes back.",
  "user.directory.empty.topPicks.browse": "Look through the room meanwhile",
  "user.directory.empty.browse": "Look through the room",

  "user.directory.empty.requests.description":
    "When someone asks to meet you, it lands here. You can ask first too, from any profile.",
  "user.directory.empty.connected.description":
    "Once you both say yes, their details land here. Nothing is shared before that.",
  "user.directory.empty.requests.title": "No one has asked yet.",

  "user.directory.empty.sentRequests.title": "Nothing pending.",
  "user.directory.empty.sentRequests.description":
    "Ask to meet someone and it shows up here, with where it stands.",

  "user.directory.empty.connected.title": "No connections yet.",

  "user.directory.empty.search.title": "Not in this room.",
  "user.directory.empty.search.description":
    'Nothing came up for "{{query}}". Search here by name, company or role. For who to meet, ask Porter on WhatsApp.',

  "user.directory.error.title": "Something went wrong",
  "user.directory.error.description":
    "We couldn't load the directory. Please try again.",
  "user.directory.error.networkTitle": "Connection issue",
  "user.directory.error.networkDescription":
    "Please check your internet connection and try again.",
  "user.directory.error.retryButton": "Try again",
  "user.directory.error.retrying": "Retrying…",

  "user.directory.profile.at": "at",

  "user.directory.requests.fullProfile": "Full profile",
  "user.directory.requests.accept": "Accept",
  "user.directory.requests.accepting": "Accepting…",
  "user.directory.requests.ignore": "Ignore",
  "user.directory.requests.ignoring": "Ignoring…",
  "user.directory.requests.undo": "Undo",
  "user.directory.requests.status.accepted": "Accepted • Contact info shared",
  "user.directory.requests.status.ignored": "Ignored",
  "user.directory.requests.requestedAgo": "Requested {{time}}",

  "user.directory.requests.sentLink": "Sent",
  "user.directory.requests.sentLinkLabel": "See the requests you sent",
  "user.directory.requests.sent.title": "Requests you sent",
  "user.directory.requests.sent.back": "Back",
  "user.directory.requests.sent.sentAgo": "Sent {{time}}",
  "user.directory.requests.sent.connected": "Connected",

  "user.directory.profile.back": "Back",
  "user.directory.profile.backToDirectory": "Directory",
  "user.directory.profile.tabs.profile": "Profile",
  "user.directory.profile.tabs.whyConnect": "Why connect",
  "user.directory.profile.linkedin.currently": "Currently",
  "user.directory.profile.linkedin.previously": "Previously",
  "user.directory.profile.linkedin.summary": "About",
  "user.directory.profile.linkedin.notAvailableFromInfo":
    "Not available from provided info",
  "user.directory.profile.whyConnect.noReasons":
    "No connection reasons available for this profile.",
  "user.directory.profile.editProfile": "Edit profile",
  "user.directory.profile.cta.requestIntro": "Request intro",
  "user.directory.profile.cta.requesting": "Requesting...",
  "user.directory.profile.cta.requestIntroHelp":
    "If your request is accepted or host-approved, you'll get each other's contact information.",
  "user.directory.profile.cta.requested": "Requested",
  "user.directory.profile.cta.requestedHelp":
    "We've notified them of your request",
  "user.directory.profile.cta.ignored": "Ignored",
  "user.directory.profile.cta.ignoredHelp":
    "You've already ignored their request",
  "user.directory.profile.cta.accept": "Accept",
  "user.directory.profile.cta.accepting": "Accepting…",
  "user.directory.profile.cta.ignore": "Ignore",
  "user.directory.profile.cta.inboundHelp": "They requested an intro {{date}}",
  "user.directory.profile.cta.email": "Copy Email",
  "user.directory.profile.cta.whatsapp": "Open WhatsApp",
  "user.directory.profile.cta.emailNotShared": "Email not shared",
  "user.directory.profile.cta.whatsappNotShared": "WhatsApp not shared",
  "user.directory.profile.cta.connectedOn": "Connected on {{date}}",
  "user.directory.profile.error.title": "Something went wrong",
  "user.directory.profile.error.description":
    "We couldn't load this profile. Please try again.",
  "user.directory.profile.error.retry": "Try again",
  "user.directory.profile.notFound.title": "Profile not found",
  "user.directory.profile.notFound.description":
    "This profile may no longer be available.",
  "user.directory.profile.error.sendRequest":
    "Failed to send request. Please try again.",
  "user.directory.profile.error.acceptRequest":
    "Failed to accept request. Please try again.",
  "user.directory.profile.error.ignoreRequest":
    "Failed to ignore request. Please try again.",
  "user.directory.profile.error.respondRequest":
    "Failed to respond to the request. Please try again.",

  "user.directory.toast.introRequested": "Intro requested",
  "user.directory.toast.introRequestedDescription":
    "We have notified {{name}} of your request",
  "user.directory.toast.connected": "Connected with {{name}}",
  "user.directory.toast.connectedDescription":
    "You can now see each other's contact information.",
  "user.directory.toast.requestDeclined": "Request ignored",
  "user.directory.toast.requestDeclinedDescription":
    "The request has been ignored",
  "user.directory.toast.rateLimitExceeded": "Intro limit reached",
  "user.directory.toast.rateLimitExceededDescription":
    "You can send up to {{limit}} intro requests every {{window}}. Try again later.",
  "user.directory.toast.requestIntroFailed": "Failed to send request",
  "user.directory.toast.requestIntroFailedDescription":
    "Please try again later",
  "user.directory.toast.respondFailed": "Failed to respond",
  "user.directory.toast.respondFailedDescription": "Please try again later",
  "user.directory.toast.noRequestId": "Unable to process request",
  "user.directory.toast.noRequestIdDescription":
    "The request could not be found. Please refresh the page.",
  "user.directory.toast.emailCopied": "Email copied",
  "user.directory.toast.emailCopiedDescription":
    "Email address copied to clipboard",
  "user.directory.toast.emailCopyFailed": "Failed to copy email",
  "user.directory.toast.emailCopyFailedDescription":
    "Could not copy the email address to clipboard",
  "user.directory.toast.noEmailAvailable": "Email not available",
  "user.directory.toast.noEmailAvailableDescription":
    "This contact does not have an email address on file",
  "user.directory.toast.noPhoneAvailable": "Phone not available",
  "user.directory.toast.noPhoneAvailableDescription":
    "This contact does not have a phone number on file",

  "user.directory.profile.requestIntroModal.title": "Add note to request",
  "user.directory.profile.requestIntroModal.placeholder":
    "Tell {{name}} why you want to connect",
  "user.directory.profile.requestIntroModal.placeholderGeneric":
    "Tell them why you want to connect",
  "user.directory.profile.requestIntroModal.charCount":
    "{{current}}/{{max}} characters",
  "user.directory.profile.requestIntroModal.messageHint":
    "Line breaks are not allowed.",
  "user.directory.profile.requestIntroModal.send": "Send",
  "user.directory.profile.requestIntroModal.sending": "Sending...",
  "user.directory.profile.requestIntroModal.close": "Close",

  "user.error.generic.title": "Something went wrong",
  "user.error.generic.description":
    "An unexpected error occurred. Please try again.",
  "user.error.notFound.title": "Page not found",
  "user.error.notFound.description":
    "The page you're looking for doesn't exist.",
  "user.error.server.title": "Server error",
  "user.error.server.description":
    "Something went wrong on our end. Please try again later.",
  "user.error.retryButton": "Try again",
  "user.error.homeButton": "Go Home",

  "user.profile.title": "Your profile",
  "user.profile.photo.title": "Your photo",
  "user.profile.photo.initialsHint":
    "Initials are what people see until you add one.",
  "user.profile.photo.currentHint": "This is what people see.",
  "user.profile.photo.choose": "Choose a photo",
  "user.profile.photo.chooseAnother": "Choose another",
  "user.profile.photo.takeNow": "Take one now",
  "user.profile.photo.remove": "Remove photo",
  "user.profile.photo.whyTitle": "Why it matters",
  "user.profile.photo.whyBody":
    "Between 76 and 90 per cent of guests arrive with a photo. Yours is the first thing someone checks before they say yes.",
  "user.profile.header.directory": "Directory",
  "user.profile.header.account": "Account",
  "user.profile.header.switchEvent": "Switch event",

  "user.profile.tabs.profile": "Profile",
  "user.profile.tabs.preferences": "Preferences",

  "user.profile.comingSoon":
    "Profile management not available yet. Coming soon!",

  "user.profile.preferences.notifications": "Notifications",
  "user.profile.preferences.incomingRequests": "Incoming requests",
  "user.profile.preferences.acceptedRequests": "Accepted requests",
  "user.profile.preferences.contactSharing": "Contact sharing",
  "user.profile.preferences.eventNotifications": "Event notifications",
  "user.profile.preferences.eventNotificationsDescription":
    "Messages from Porter about the event itself, separate from your intro requests.",
  "user.profile.preferences.whatsapp": "WhatsApp",
  "user.profile.preferences.email": "Email",
  "user.profile.preferences.realTime": "Real-time",
  "user.profile.preferences.off": "Off",
  "user.profile.preferences.contactSharingDescription":
    "Choose the contact information the other person receives when you connect.",
  "user.profile.preferences.contactSharingError":
    "Pick at least one. It's only shared when both people accept.",
  "user.profile.preferences.errorLoading":
    "Failed to load preferences. Please try again.",
  "user.profile.preferences.errorSaving":
    "Failed to save preferences. Please try again.",
  "user.profile.preferences.futureEvents.title": "Future events",
  "user.profile.preferences.futureEvents.buttonRemember":
    "Remember me for future events",
  "user.profile.preferences.futureEvents.buttonRemembered":
    "Remembered for future events",
  "user.profile.preferences.futureEvents.description":
    "Planta helps you stay close to the people you met, discover new ones, and build your connection history across events (not just LTF). Planta is separate from LTF and Riverwood. By clicking, you become a member, or if you're already part of Planta, this info is added to your record — compounding your profile for the next event. You agree to the {{terms}} and {{privacy}}.",
  "user.profile.preferences.futureEvents.termsLabel": "Terms",
  "user.profile.preferences.futureEvents.privacyLabel": "Privacy Policy",
  "user.profile.preferences.export.sectionLabel": "Directory",
  "user.profile.preferences.export.title": "Directory export",
  "user.profile.preferences.export.description":
    "Sends you every participant in the directory as a spreadsheet on WhatsApp: name, role, bio, LinkedIn summary, Why Connect and LinkedIn. It carries no email addresses and no phone numbers, for anyone.",
  "user.profile.preferences.export.descriptionNoWhyConnect":
    "Sends you every participant in the directory as a spreadsheet on WhatsApp: name, role, bio, LinkedIn summary and LinkedIn. It carries no email addresses and no phone numbers, for anyone.",
  "user.profile.preferences.export.button": "Send to WhatsApp",
  "user.profile.preferences.export.modal.title": "Send the directory?",
  "user.profile.preferences.export.modal.body":
    "Porter will send you the directory as a spreadsheet on WhatsApp.",
  "user.profile.preferences.export.modal.confirm": "Send it",
  "user.profile.preferences.export.modal.cancel": "Cancel",
  "user.profile.preferences.export.modal.sending": "Sending…",
  "user.profile.preferences.export.modal.queuedTitle": "On its way",
  "user.profile.preferences.export.modal.queuedBody":
    "Porter is sending you the directory on WhatsApp. Open your chat with Porter to find it.",
  "user.profile.preferences.export.modal.needsInboundTitle":
    "Message Porter first",
  "user.profile.preferences.export.modal.needsInboundBody":
    "WhatsApp only lets Porter send you a file within 24 hours of your last message. Send Porter a message, then come back and try again.",
  "user.profile.preferences.export.modal.errorBody":
    "Something went wrong sending the directory. Please try again.",
  "user.profile.preferences.export.modal.close": "Close",

  "user.profile.form.addPhoto": "Add a photo",
  "user.profile.form.changePhoto": "Change photo",
  "user.profile.form.uploading": "Uploading…",
  "user.profile.form.removePhoto": "Remove",
  "user.profile.form.removing": "Removing…",
  "user.profile.form.firstName": "First name",
  "user.profile.form.lastName": "Last name",
  "user.profile.form.fullName": "Full name",
  "user.profile.form.nickName": "Nickname",
  "user.profile.form.title": "Title",
  "user.profile.form.titlePlaceholder": "Your professional title",
  "user.profile.form.company": "Company",
  "user.profile.form.bio": "Bio summary",
  "user.profile.form.bioPlaceholder": "Tell others about yourself",
  "user.profile.form.summary": "LinkedIn summary",
  "user.profile.form.summaryPlaceholder": "Your LinkedIn summary",
  "user.profile.form.whatPeopleSee": "What people see",
  "user.profile.form.porterReads":
    "Porter reads this to decide who to bring you. None of it reaches anyone until you accept them.",
  "user.profile.form.save": "Save",
  "user.profile.form.saving": "Saving…",
  "user.profile.form.openInDirectory": "Open in Directory",
  "user.profile.form.errorLoading":
    "Failed to load profile data. Please try again.",
  "user.profile.form.errorSaving": "Failed to save changes. Please try again.",
  "user.profile.form.errorMissingId":
    "Missing participant ID. Please reload the page.",
  "user.profile.form.photoTooLarge": "Photo is too large (max {{maxSize}}MB)",
  "user.profile.form.invalidPhotoType":
    "Invalid photo type. Please upload a JPEG, PNG, or WebP image.",
  "user.profile.form.notProvided": "Not provided",

  "user.account.header.subtitle": "User Account & Preferences",
  "user.account.header.closeLabel": "Close",
  "user.account.header.back": "Back",

  "user.account.title": "Your Planta account",
  "user.account.tabs.settings": "Settings",
  "user.account.tabs.events": "Events",

  "user.account.settings.email": "Email",
  "user.account.settings.whatsapp": "WhatsApp",
  "user.account.settings.linkedin": "LinkedIn",
  "user.account.settings.verified": "Verified",
  "user.account.settings.unverified": "Unverified",
  "user.account.settings.sendVerification": "Send verification code",
  "user.account.settings.verificationSent": "Sending code…",
  "user.account.settings.enterCode": "Enter code",
  "user.account.settings.verify": "Verify",
  "user.account.settings.verifySuccess": "Email verified.",
  "user.account.settings.verifyError": "Verification failed. Please try again.",
  "user.account.settings.rateLimited":
    "Too many attempts. Please try again later.",
  "user.account.settings.footer": "To update these details, write to",
  "user.account.settings.footerEmail": "help@planta.network",

  "user.account.events.past": "Past",
  "user.account.events.noUpcoming": "No upcoming events",
  "user.account.events.noPast": "No past events",

  "user.eventLanding.whatsapp.defaultMessage": "Hi Porter!",
  "user.eventLanding.errorState.message":
    "Unable to load event information. Please check the link and try again.",
  "user.eventLanding.invalidLink":
    "Invalid event link. Please check the URL and try again.",
  "user.eventLanding.loadingLabel": "Loading event",
  "user.eventLanding.eyebrow": "@{{eventName}}",
  "user.ltf.invitedBy": "Invited by {{host}}",
  "user.ltf.poweredBy": "Powered by Planta",
  "user.ltf.hero.suffix": "Your Event Connection Concierge",
  "user.ltf.feature.directory": "Get access to the participant directory.",
  "user.ltf.feature.intros":
    "Request intros to other LTF participants and connect over WhatsApp or email.",
  "user.ltf.feature.materials":
    "Access the agenda, event map, pre-read materials, and others.",
  "user.ltf.cta.openWhatsapp": "Open LTF Hub with WhatsApp →",
  "user.ltf.qr.toggle": "Or scan QR code on your phone",
  "user.ltf.qr.caption": "Opens a WhatsApp chat with LTF Hub",
  "user.ltf.qr.alt": "QR code to open LTF Hub on WhatsApp",
  "user.ltf.legal.intro": "By continuing, you agree to our ",
  "user.ltf.legal.privacy": "Privacy Policy",
  "user.ltf.legal.and": " and ",
  "user.ltf.legal.terms": "Terms",
  "user.ltf.encryption":
    "Messages are end-to-end encrypted. Your number is only shared with people you choose.",
  "user.eventLanding.headline": "Connect with the right people",
  "user.eventLanding.lede": "Your agent Porter is here to help you find them.",
  "user.eventLanding.ledeWithCount":
    "{{count}} people are coming. Your agent Porter is here to help you find them.",
  "user.eventLanding.facesMore": "{{count}}",
  "user.eventLanding.steps.tellPorter": "Tell Porter why you are here",
  "user.eventLanding.steps.suggestions": "Receive suggestions tailored for you",
  "user.eventLanding.steps.connect":
    "Connect via email, or WhatsApp, when both say yes.",
  "user.eventLanding.organizedBy": "Organized by",
  "user.eventLanding.supportedBy": "Supported by",
  "user.eventLanding.cta.openWhatsapp": "Start on WhatsApp",
  "user.eventLanding.desktopQr.title": "Scan to start on WhatsApp",
  "user.eventLanding.desktopQr.caption":
    "Point your phone's camera at the code to open a chat with Porter.",
  "user.eventLanding.desktopQr.fallback": "Open WhatsApp on this computer",
  "user.eventLanding.tv.caption": "Scan with your phone to join",
  "user.eventLanding.tv.present": "Full screen",
  "user.eventLanding.tv.exit": "Exit",
  "user.eventLanding.cta.scanQr": "Or scan a QR code on your phone",
  "user.eventLanding.qrCaption": "Opens a WhatsApp chat with Porter",
  "user.eventLanding.legal.intro": "What you tell Porter stays private.",
  "user.eventLanding.legal.body":
    "By continuing you agree to our {{privacy}} and {{terms}}.",
  "user.eventLanding.legal.privacyLabel": "Privacy Policy",
  "user.eventLanding.legal.termsLabel": "Terms",
} as const satisfies TranslationDictionaryType;

declare module "@shared/types/translation-key.types" {
  interface TranslationKeyRegistry {
    user: keyof typeof en;
  }
  interface TranslationValueRegistry {
    user: typeof en;
  }
}
